import React, { useEffect } from 'react'
import { Header } from '../components/layout/Header'
import { Footer } from '../components/layout/Footer'
import SEO from '../components/SEO'

const TermsOfUse: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div className="min-h-screen bg-white font-sans text-fg-2">
      <SEO 
        title="Terms of Use | Jobloads" 
        description="Review the terms and conditions for using the Jobloads website and services."
        canonicalPath="/terms"
      />
      <Header />
      
      <main className="max-w-[800px] mx-auto px-6 md:px-8 py-12 md:py-24">
        <h1 className="text-[clamp(36px,5vw,60px)] font-semibold leading-[1.02] tracking-[-0.03em] text-midnight-blue mb-8 md:mb-12">
          Terms of use
        </h1>
        
        <div className="space-y-8 md:space-y-10 text-[19px] md:text-[21px] leading-[1.6] text-fg-3 font-subheading">
          <p>
            Last updated: 29 April 2026
          </p>
          
          <section className="space-y-4 md:space-y-6">
            <h2 className="text-[24px] md:text-[28px] font-semibold text-midnight-black font-sans tracking-tight">Agreement to terms</h2>
            <p>
              By accessing this website, you agree to follow these terms of use. If you do not agree, please do not use the site.
            </p>
          </section>

          <section className="space-y-4 md:space-y-6">
            <h2 className="text-[24px] md:text-[28px] font-semibold text-midnight-black font-sans tracking-tight">Purpose of the site</h2>
            <p>
              This website is for informational purposes only. It provides details about Jobloads Limited and our upcoming transport network, Crewloads. The content on this site is subject to change as we develop our products.
            </p>
          </section>

          <section className="space-y-4 md:space-y-6">
            <h2 className="text-[24px] md:text-[28px] font-semibold text-midnight-black font-sans tracking-tight">Intellectual property</h2>
            <p>
              All content on this site, including text, graphics, and logos, belongs to Jobloads Limited or our partners. You may not use or reproduce any of this content without our written permission.
            </p>
          </section>

          <section className="space-y-4 md:space-y-6">
            <h2 className="text-[24px] md:text-[28px] font-semibold text-midnight-black font-sans tracking-tight">Acceptable use</h2>
            <p>
              You agree to use this site only for lawful purposes. You must not attempt to disrupt the site's security or use it to transmit harmful or offensive material.
            </p>
          </section>

          <section className="space-y-4 md:space-y-6">
            <h2 className="text-[24px] md:text-[28px] font-semibold text-midnight-black font-sans tracking-tight">Disclaimer and liability</h2>
            <p>
              We provide this site "as is" and do not guarantee that the information is always accurate or complete. To the maximum extent permitted by New Zealand law, we are not liable for any loss or damage resulting from your use of this site.
            </p>
          </section>

          <section className="space-y-4 md:space-y-6">
            <h2 className="text-[24px] md:text-[28px] font-semibold text-midnight-black font-sans tracking-tight">Governing law</h2>
            <p>
              These terms are governed by the laws of New Zealand. Any disputes related to these terms will be handled by the New Zealand courts.
            </p>
          </section>

          <section className="space-y-4 md:space-y-6">
            <h2 className="text-[24px] md:text-[28px] font-semibold text-midnight-black font-sans tracking-tight">Contact us</h2>
            <p>
              If you have any questions about these terms, please contact us at hello@jobloads.com.
            </p>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  )
}

export default TermsOfUse
